module.exports = __webpack_public_path__ + "img/83.f655b914.png";